/**
 * Created by mykurisu on 2017/9/13.
 */
import React from 'react'
import {Link, browserHistory} from 'react-router'
import { connect } from 'react-redux'
import {TimeStream, isAndroid, getJsonFromUrl, replaceAllmatching} from '../../utils'
import Popular from '../../images/channel-person-cuont.png'
import Discuss from '../../images/recorded/discuss.png'
import Evaluation from '../../images/recorded/eva.png'
import {filterHTML} from "../../utils/index";
import PurchaseNotesModal from '../../components/PurchaseNotesModal'

class Infobar extends React.Component {
    constructor(){
        super()
        this.state = {
            isShowPurchaseModal: false
        }
    }
    componentDidMount () {
        if (getJsonFromUrl().share_platform === 'app') {
            this.props.dispatch({ type: 'MTA_CLICK', payload: 'app-share-show-download' })
        }
    }
    onClickDownload () {
        this.props.dispatch({ type: 'MTA_CLICK', payload: 'app-share-lecture-click-download' })
        location.assign('https://a.app.qq.com/o/simple.jsp?pkgname=com.lizhiweike')
    }
    onShowEvaluationPanel() {
        window.MtaH5 && window.MtaH5.clickStat('lecture_evaluation_show_record')
        this.props.dispatch({type: 'WK_SET_IS_AUDIO_LAST'})
        if (window.systemType === 'android') {
            this.props.dispatch({type: 'LECTURE_HIDE_VIDEO'})
        }
    }
    purchaseNotes() {
        this.setState({
            isShowPurchaseModal: true
        })
    }
    ClosePurchaseNotesModal() {
        this.setState({
            isShowPurchaseModal: false
        })
    }
    render() {
        const isFromApp = getJsonFromUrl().share_platform === 'app'
        const {description} = this.props.lecture
        const newDescription = replaceAllmatching('img.weike.fm','img2.lizhiweike.com',description)
        console.log("infobar:", this.props.isEvaEntryShow)
        return (
            <div className="recorded-infobar">
                {this.props.channel && !this.props.isMinaApp &&
                <div className="channel-info">
                    <Link to={`/channel/${this.props.channel.id}`}>
                        <div className="title">
                            <div className="title-img"
                                 style={{backgroundImage: `url(${this.props.channel.cover_url})`}}>

                            </div>
                            <div className="title-text">
                                <p>{this.props.channel.name}</p>
                                <p>已更新{this.props.channel.channel_lecture_count}期</p>
                            </div>
                        </div>
                    </Link>
                    {!this.props.channelAccess.granted &&
                    <Link to={`/channel/${this.props.channel.id}`}>
                        <div className="focus-btn">
                            订阅
                        </div>
                    </Link>
                    }
                </div>
                }
                <div className="lecture-info">
                    <div className="info-title">
                        {this.props.lecture.name}
                    </div>
                    <div className="info-count" style={{display: 'none'}}>
                        <div className="count-popular">
                            <img src={Popular} alt=""/>
                            <span>{this.props.stats.popular}</span>
                        </div>
                        <div className="count-discuss" style={{display: 'none'}}>
                            <img src={Discuss} alt=""/>
                            <span>0</span>
                        </div>
                    </div>
                    
                    {/*弹出购买须知*/}
                    {this.state.isShowPurchaseModal &&
                    <PurchaseNotesModal ClosePurchaseNotesModal={()=>this.ClosePurchaseNotesModal()}/>
                    }

                    <div className="info-time">
                        <div className="info-time-left">
                            {(this.props.lecture.lecture_mode !== 'video' && this.props.lecture.lecture_mode !== 'audio') &&
                            <span>{TimeStream(this.props.lecture.start_timestamp, 'YMD')}</span>
                            }
                            <span>{this.props.stats.popular}</span>人气
                        </div>

                        <div className="info-time-right">
                            {this.props.isEvaEntryShow && false &&
                            <span style={{lineHeight: '14px'}}  onClick={e => this.onShowEvaluationPanel()}>
                                <img className="info-evaluation-img" src={Evaluation} alt=""/>
                                <span className="info-evaluation">对课程进行评价</span>
                            </span>
                             }
                            {(this.props.lecture.lecture_mode === 'video' || this.props.lecture.lecture_mode === 'audio') ?
                            <span  style={{lineHeight: '14px'}} onClick={() => {this.purchaseNotes()}}>
                                <span className="info-evaluation">购买须知</span>
                            </span>: null}

                            <span  style={{lineHeight: '14px'}}  onClick={() => {location.assign(`/complain/lecture/${this.props.lecture.id}`)}}>
                                <img className="info-evaluation-img" src={Evaluation} alt=""/>
                                <span className="info-evaluation">投诉</span>
                            </span>
                        </div>
                    </div>
                    {
                        isFromApp && (
                            <div className="download-app" onClick={e => this.onClickDownload()}>
                                使用APP全程回顾，永久回听
                            </div>
                        )
                    }
                </div>

                {description !== '' &&
                <div className="lecture-intro">
                    <section dangerouslySetInnerHTML={{__html: filterHTML(newDescription)}}/>
                </div>
                }

                <div className="back-old">
                    <span>
                        {!this.props.isMinaApp &&
                        <Link to={`/complain/lecture/${this.props.lecture.id}`}>
                            投诉
                        </Link>
                        }
                    </span>
                </div>
            </div>
        )
    }
}

export default connect(state => ({
    isEvaEntryShow: state.wk.wkEvaluation.isShowEntry
}))(Infobar)


// WEBPACK FOOTER //
// ./src/pages/recordedPage/Infobar.js